/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Rail_BestInputs */

const en_ui_rail_best = /** @type {(inputs: Ui_Rail_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`best`)
};

const de_ui_rail_best = /** @type {(inputs: Ui_Rail_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beste`)
};

/**
* | output |
* | --- |
* | "best" |
*
* @param {Ui_Rail_BestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_rail_best = /** @type {((inputs?: Ui_Rail_BestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Rail_BestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_rail_best(inputs)
	return de_ui_rail_best(inputs)
});